'use strict';

const greekToTransliteratedLatinMap = [
	{ find: 'α', replace: 'a' },
	{ find: 'β', replace: 'v' },
	{ find: 'γ', replace: 'g' },
	{ find: 'δ', replace: 'd' },
	{ find: 'ε', replace: 'e' },
	{ find: 'ζ', replace: 'z' },
	{ find: 'η', replace: 'ē' },
	{ find: 'θ', replace: 'th' },
	{ find: 'ι', replace: 'i' },
	{ find: 'κ', replace: 'k' },
	{ find: 'λ', replace: 'l' },
	{ find: 'μ', replace: 'm' },
	{ find: 'ν', replace: 'n' },
	{ find: 'ξ', replace: 'x' },
	{ find: 'ο', replace: 'o' },
	{ find: 'π', replace: 'p' },
	{ find: 'ρ', replace: 'r' },
	{ find: 'σ', replace: 's' },
	{ find: 'ς', replace: 's' },
	{ find: 'τ', replace: 't' },
	{ find: 'υ', replace: 'u' },
	{ find: 'φ', replace: 'ph' },
	{ find: 'χ', replace: 'kh' },
	{ find: 'ψ', replace: 'ps' },
	{ find: 'ω', replace: 'ō' },

	{ find: 'ά', replace: 'á' },
	{ find: 'έ', replace: 'é' },
	{ find: 'ί', replace: 'í' },
	{ find: 'ό', replace: 'ó' },
	{ find: 'ύ', replace: 'ú' },
	{ find: 'ή', replace: 'ḗ' },
	{ find: 'ώ', replace: 'ṓ' },
	{ find: 'ϊ', replace: 'ï' },
	{ find: 'ϋ', replace: 'ü' },
	{ find: 'ΰ', replace: 'ǘ' },
	{ find: 'ΐ', replace: 'ḯ' },

	{ find: 'Α', replace: 'A' },
	{ find: 'Β', replace: 'V' },
	{ find: 'Γ', replace: 'G' },
	{ find: 'Δ', replace: 'D' },
	{ find: 'Ε', replace: 'E' },
	{ find: 'Ζ', replace: 'Z' },
	{ find: 'Η', replace: 'Ē' },
	{ find: 'Θ', replace: 'Th' },
	{ find: 'Ι', replace: 'I' },
	{ find: 'Κ', replace: 'K' },
	{ find: 'Λ', replace: 'L' },
	{ find: 'Μ', replace: 'M' },
	{ find: 'Ν', replace: 'N' },
	{ find: 'Ξ', replace: 'X' },
	{ find: 'Ο', replace: 'O' },
	{ find: 'Π', replace: 'P' },
	{ find: 'Ρ', replace: 'R' },
	{ find: 'Σ', replace: 'S' },
	{ find: 'Τ', replace: 'T' },
	{ find: 'Υ', replace: 'U' },
	{ find: 'Φ', replace: 'Ph' },
	{ find: 'Χ', replace: 'Kh' },
	{ find: 'Ψ', replace: 'Ps' },
	{ find: 'Ω', replace: 'Ō' },

	{ find: 'Ά', replace: 'Á' },
	{ find: 'Έ', replace: 'É' },
	{ find: 'Ί', replace: 'Í' },
	{ find: 'Ό', replace: 'Ó' },
	{ find: 'Ύ', replace: 'Ú' },
	{ find: 'Ή', replace: 'Ḗ' },
	{ find: 'Ώ', replace: 'Ṓ' },
	{ find: 'Ϊ', replace: 'Ï' },
	{ find: 'Ϋ', replace: 'Ü' },

	{ find: ';', replace: '?' }
];

module.exports = greekToTransliteratedLatinMap;
